import { render, staticRenderFns } from "./stock-legend.vue?vue&type=template&id=c91b9e10&"
import script from "./stock-legend.vue?vue&type=script&lang=js&"
export * from "./stock-legend.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports